import type { ReactNode } from "react";
import { useDataSyncPoll, UseDataSyncPollArgs } from "../hooks/custom-hooks/use-data-sync-polling";

export interface TellescopeDataSyncPollingProviderArgs extends UseDataSyncPollArgs {
  children: ReactNode;
}

export const TellescopeDataSyncPollingProvider = ({ children, ...rest }: TellescopeDataSyncPollingProviderArgs) => {
  useDataSyncPoll(rest);

  return children;
};
